import { resolveDrawerSize } from "@shared/ui/enterprise-drawer/drawerSize";
import { useStoredUser } from "@shared/useStoredUser";
import type { MenuProps } from "antd";
import { Avatar, Drawer, Flex, Menu, Typography, theme } from "antd";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router";
import logo from "../assets/logo-metrica.svg";
import { findCurrentSection, getNavSections, getSiderItems } from "./navigationConfig";

interface MobileNavDrawerProps {
  open: boolean;
  onClose: () => void;
}

export function MobileNavDrawer({ open, onClose }: MobileNavDrawerProps) {
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const location = useLocation();
  const storedUser = useStoredUser();

  const sections = useMemo(() => getNavSections(storedUser), [storedUser]);
  const items = useMemo(() => getSiderItems(sections), [sections]);

  const selectedKeys = useMemo(() => {
    const section = findCurrentSection(location.pathname, sections);
    return section ? [section.key] : [];
  }, [location.pathname, sections]);

  const handleClick: MenuProps["onClick"] = ({ key }) => {
    if (typeof key !== "string") {
      return;
    }
    const section = sections.find((s) => s.key === key);
    if (section) {
      navigate(section.defaultPath);
      onClose();
    }
  };

  return (
    <Drawer
      placement="left"
      size={resolveDrawerSize(280)}
      open={open}
      onClose={onClose}
      styles={{
        body: { padding: 0, background: token.colorBgContainer },
      }}
      title={
        <Flex align="center" gap={8}>
          <Avatar shape="square" size={24} src={logo} />
          <Typography.Text>Навигация</Typography.Text>
        </Flex>
      }
    >
      <Menu mode="inline" items={items} selectedKeys={selectedKeys} onClick={handleClick} />
    </Drawer>
  );
}
